import $ = require('jquery');
import 'preload-js';
import Config = require("./config/Config");
import CoolingView = require("./view/CoolingView");
import KVView = require("./view/KVView");
import EngineeringView = require("./view/EngineeringView");
import SoftwareView = require("./view/SoftwareView");
import ExperienceView = require("./view/ExperienceView");
import PlayerView = require("./view/PlayerView");
import LoadingView = require("./view/LoadingView");
import ScrollView = require("./ScrollView");
import GoogleAnalyticsService = require("./service/GoogleAnalyticsService");
import YTPlayer = require("./media/YTPlayer");

module app {

    // declare var $: any;

    $(function () {
        let config: Config = Config.instance();
        config.init();

        $(window).on("resize", onWindowResize);

        createScrollView();
        createLoadingView();
        loadYTApi();
        createViews();
        // loadAssets();
    });


    /*
    * YoutubeApi
    * */
    function loadYTApi() {
        const myDoc = (<any>window).document;
        let playerApiScript = myDoc.createElement('script');
        playerApiScript.type = 'text/javascript';
        playerApiScript.src = 'https://www.youtube.com/iframe_api';
        myDoc.body.appendChild(playerApiScript);
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(playerApiScript, firstScriptTag);
        (<any>window).onYouTubeIframeAPIReady = () => {
            createPlayerView();
            createLoopPlayer();
            createVideoBtn();
        };
    }


    let loader: createjs.LoadQueue;
    let assetArr: string[] = [
        "assets/img/kv/bg-kv.jpg",
        "assets/img/kv/product-kv.png",
        "assets/img/cooling/parallax-bg-cooling.jpg",
        "assets/img/engineering/parallax-bg-engineering.jpg",
        "assets/img/software/parallax-bg-software.jpg",
    ];

    function loadAssets() {

        let loadArr: any[] = [];
        for (let i: number = 0; i < assetArr.length; i++) {
            loadArr.push({id: assetArr[i], src: assetArr[i]});
        }

        loader = new createjs.LoadQueue();
        loader.on("progress", (event: any) => {
            let percent: number = Math.floor(event.loaded * 100);
            loadingView.onProgress(percent);
        });
        loader.on("complete", () => {
            createViews();
        });
        loader.loadManifest(loadArr);
    }


    let scrollView: ScrollView;
    let scrollTop: number = 0;

    function createScrollView(): void {
        scrollTop = 0;
        scrollView = new ScrollView($(window), $("body,html"));
        scrollView.emitter.on(ScrollView.ScrollEvent.ON_SCROLL, onWindowScroll);
    }

    function onWindowScroll(result: number): void {
        scrollTop = result;
        for (let key in renderChildren) {
            if (renderChildren.hasOwnProperty(key)) {
                renderChildren[key].onScroll(scrollTop);
            }
        }
    }


    function onWindowResize(event: JQuery.Event) {
        fixAsusWrapper();
        for (let key in renderChildren) {
            if (renderChildren.hasOwnProperty(key)) {
                renderChildren[key].resize();
            }
        }
        onWindowScroll(scrollTop);
    }

    function fixAsusWrapper() {
        let baseW: number = $("#special-sectionOverview, #sectionOverview").width();
        let targetX: number = (baseW - window.innerWidth) * 0.5;
        $("#fixASUSWrapper").css({
            'left': targetX + 'px',
            'width': window.innerWidth + 'px'
        });
    }


    let playerView: PlayerView;

    function createPlayerView() {
        playerView = new PlayerView($("#youtubeView"));
    }

    let loopPlayer: YTPlayer;

    function createLoopPlayer() {
        loopPlayer = new YTPlayer("ytPlayer-loop", "qtuGvYwVMBs", true, true, false, true);
        loopPlayer.emitter.on(YTPlayer.VideoEvent.PLAYER_READY, () => {
        });
        loopPlayer.emitter.on(YTPlayer.VideoEvent.ON_PLAYING, () => {
            $(".coverBtn").addClass("video-playing");
        });
    }

    function createVideoBtn(): void {
        $(".videoBtn").each((index, element) => {
            $(element).addClass("active");
            $(element).on("click tap", (event: JQuery.Event) => {
                event.preventDefault();
                let trackingCode: string = $(element).data("tracking");
                GoogleAnalyticsService.instance().sendTracking(
                    'event',
                    'videos',
                    'played',
                    trackingCode
                );
                playerView.tracking = trackingCode;
                playerView.playVideo($(element).data("video"));
            });
        });
    }


    let loadingView: LoadingView;

    function createLoadingView() {
        loadingView = new LoadingView($("#loadingView"));
    }


    /*
    * Views
    * */
    let viewData: any[] = [
        {selector: "#kvView", class: KVView},
        {selector: "#coolingView", class: CoolingView},
        {selector: "#experienceView", class: ExperienceView},
        {selector: "#engineeringView", class: EngineeringView},
        {selector: "#softwareView", class: SoftwareView}
    ];
    let renderChildren: any = {};

    function createViews() {

        for (let i: number = 0; i < viewData.length; i++) {
            let ViewClass: any = viewData[i]["class"];
            renderChildren[viewData[i]["selector"]] = new ViewClass($(viewData[i]["selector"]));
        }
        setTimeout(() => {
            onWindowResize(null);
            loadingView.transitionOut();
            createTimer();
        }, 1000);
    }


    let fixId: number = 0;
    let fixTimer: any;

    function createTimer() {
        if (fixTimer) clearTimer();
        if (fixId < 3) {
            fixTimer = window.setTimeout(() => {
                fixId++;
                clearTimer();
                onWindowResize(null);
                createTimer();
            }, 500);
        }
    }

    function clearTimer() {
        window.clearTimeout(fixTimer);
        fixTimer = null;
    }

}